import { Loader } from "@dreamhub/designsystem/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";

export const LoadingState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="h-full flex flex-col items-start justify-start p-8"
      data-test="global-search-loading-state"
    >
      <div className="flex ">
        <Text variant="bodySecondary">
          {t("globalSearch.loadingState.searching")}
        </Text>
      </div>
      <IconContainer size="lg" className="self-center justify-center mb-6">
        <Loader />
      </IconContainer>
    </div>
  );
};
